module.exports = __webpack_public_path__ + "media/images/emblems/Roggliswil_LU-8063e1e4603aa024a112622de262f45e.png";